module.exports = __webpack_public_path__ + "static/media/img_dance_11.86216736.png";